<template>
  <base-modal
    :title="$t('modal.userSettings.title')"
    :confirmButton="$t('modal.userSettings.confirmBtn')"
    :customShowDialog="showUserSettingsModal"
    @close="handleClose"
    @confirmed="handleUpdateClick"
  >
    <div slot="body">
      <v-layout column wrap style="height: 50vh">
        <v-flex xs6>
            <p class="text-xs-left subheading mb-0">{{ $t('modal.userSettings.defaultSourceLabel') }}</p>
            <v-radio-group v-model="searchSetting" class="pt-1" id="select-source">
              <v-radio
                v-for="n in searchOptions"
                :key="n.name"
                :label="n.name"
                :value="n"
              ></v-radio>
            </v-radio-group>
        </v-flex>
        <v-flex xs6>
          <p class="text-xs-left subheading mb-0">{{ $t('modal.userSettings.snapToGridLabel') }}</p>
          <v-radio-group v-model="snapSetting" class="pt-1">
            <v-radio
              v-for="n in snapOptions"
              :key="n.name"
              :label="`${n.name}`"
              :value="n"
            ></v-radio>
          </v-radio-group>
          <p class="text-xs-left subheading mb-0">{{ $t('modal.userSettings.phraseSearchingLabel') }}</p>
          <v-checkbox
            slot="activator"
            :label="$t('modal.userSettings.phraseSearchingOptions.addQuotes')"
            v-model="addQuotesAroundPhrasesSetting"
            hide-details
            class="pt-1"
          ></v-checkbox>
        </v-flex>
      </v-layout>
    </div>
  </base-modal>
</template>

<script>

import { snapOptions, snapOff } from '@/utils/constants'
import { getSnapToGrid, getDefaultSearch, getUserDetails, setUserDetails,
  getAddQuotesAroundPhrases } from '@/utils/user-details'
import { POSSIBLE_ENGINES, DEFAULT_ENGINE } from '@/utils/search-engines'
import { setAttributes as apiSetUserAttributes } from '@/utils/users-api'
import { statusEnum } from '@/utils/api-common'

export default {
  name: 'user-settings-modal',
  components: {BaseModal: () => import('./BaseModal')},
  data () {
    return {
      snapSetting: snapOff,
      searchSetting: DEFAULT_ENGINE,
      addQuotesAroundPhrasesSetting: true
    }
  },
  computed: {
    showUserSettingsModal: { get () { return this.$store.state.modalState.showUserSettingsModal } },
    snapOptions: function () {
      return snapOptions
    },
    searchOptions: function () {
      return POSSIBLE_ENGINES.filter(x => {
        return x.enabled
      })
    }
  },
  mounted () {
    const userSnapToGrid = getSnapToGrid() || snapOff
    this.snapSetting = snapOptions.find((x) => {
      return x.name === userSnapToGrid.name
    })
    const userDefaultSearch = getDefaultSearch()
    const e = POSSIBLE_ENGINES.find(x => {
      return x.name === userDefaultSearch.name
    })
    if (e) {
      this.searchSetting = e
    } else {
      this.searchSetting = DEFAULT_ENGINE
    }
    const addQuotesAroundPhrases = getAddQuotesAroundPhrases()
    this.addQuotesAroundPhrasesSetting = addQuotesAroundPhrases
  },
  methods: {
    handleUpdateClick () {
      let d = getUserDetails()
      if (typeof d === 'undefined' || d === null) {
        d = {}
      }
      d.snapToGridName = this.snapSetting.name
      d.defaultSearchName = this.searchSetting.name
      d.addQuotesAroundPhrases = this.addQuotesAroundPhrasesSetting
      setUserDetails(d)

      apiSetUserAttributes({
        snapToGridName: this.snapSetting.name,
        defaultSearchName: this.searchSetting.name,
        addQuotesAroundPhrases: this.addQuotesAroundPhrasesSetting
      }).then(r => {
        if (r.status === statusEnum.ok) {
          this.$emit('updated')
        } else {
          this.$emit('failed')
        }
      })
    },
    handleClose () {
      this.$store.commit('setShowUserSettingsModal', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#select-source {
  display: initial;
}
// @todo - Have source as one column and snap to grid/ as another
#select-source > div.input-group__input  {
  display: flex;
  flex-direction: column;
  height: 150px;
  flex-wrap: wrap;
  width: 17vw;
}

</style>



// WEBPACK FOOTER //
// src/components/modals/UserSettingsModal.vue